import {Device} from '../../constants';
import styled from 'styled-components';

const TooltipStyled = styled.div`
  position: relative;
  display: inline-block;
  max-width: 90vw;
  font-size: 12px;
  .ecr-tooltip-wrapper {
    position: absolute;
    bottom: calc(100% - 1em);
    .ecr-tooltip-popup {
      padding: 15px;
      position: relative;
      display: none;
      background: white;
      visibility: hidden;
      left: -90%;
      margin-bottom: 15px;
      opacity: 0;
      transition: all 0.3s linear;
      max-width: 90vw;
      @media screen and ${Device.mobileL} {
        flex-wrap: wrap;
        min-width: 300px;
      }
      &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: calc(90% + 6px);
        border-width: 6px;
        border-style: solid;
        border-color: white transparent transparent transparent;
      }
      img {
        align-self: center;
        max-width: 250px;
        margin-top: -15px;
      }
      .ecr-tooltip-tip {
        padding: 3%;
        min-width: 300px;
        font-size: 12px;
        @media screen and ${Device.mobileL} {
          min-width: unset;
        }
      }
    }
    .ecr-tooltip-icon {
      cursor: pointer;
      border-radius: 50%;
      width: 2em;
      height: 2em;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid black;
      font-weight: 1000;
    }
    &:hover {
      .ecr-tooltip-popup {
        visibility: visible;
        opacity: 1;
        display: flex;
      }
      .ecr-tooltip-icon {
        color: white;
        background: black;
      }
    }
  }
`;

export default TooltipStyled;
